import { Component, OnInit, ViewChild } from '@angular/core';
import { CourseService } from '../services/course.service';
import { Observable } from 'rxjs';

import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { AddCourseModalComponent } from './add-course-modal/add-course-modal.component';
import { EditCourseModalComponent } from './edit-course-modal/edit-course-modal.component';
import { FilterService } from "../services/filter.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UtilityService } from './../services/utility.service'
declare let $;



@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})

export class CoursesComponent implements OnInit {
  loading: Boolean;
  courses: any = [];
  length;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  view;
  displayedColumns: string[] = ['title', 'duration', 'exam', 'actions'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  sortedData: []
  afterFilter: any;
  filterActive: Boolean = false;
  noDataMsg = {
    title: "No Courses!",
    data: "You have not yet added any courses"
  }
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(private router: Router, public _courseService: CourseService, public dialog: MatDialog, public _filter: FilterService, public _snackBar: MatSnackBar, public _utilityService: UtilityService) {
    this.courses = [];
    this.dataSource = new MatTableDataSource(this.courses);
    this.sortedData = this.courses.slice();

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  filter(searchText) {
    this.afterFilter = null
    console.log('FILTER CALLED', searchText);
    this.filterActive = true;
    if (searchText === '') {
      this.filterActive = false;
      this.updateData(this.courses)
    }
    let filteredCourses = this._filter.filter(searchText, this.courses, ['title']);
    this.updateData(filteredCourses)
    if (filteredCourses.length <= 0) {
      // this.afterFilter = "No Courses with matched search text found!"
      this.afterFilter = {
        title: "No Courses!",
        data: "Sorry, no courses matched your search"
      }
    }
  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }
  ngOnInit() {
    console.log("VALUE OF COURSES IS", this.courses);

    this.loading = true;
    this.getCourses();
    if (this.router.url.includes('/dashboard')) {
      this.view = true;
      console.log("VIEW VALUE IS", this.view)
      $('#course-table-height').addClass('table-height');
    }
  }

  reditectToMaterials(data) {
    console.log("data in redirection", data)
    // if(data && data.portfolioId){
    //   this.router.navigate(['/materials/'+ data._id], { queryParams: { portfolioId: data.portfolioId} })
    // }
    // else{
    let param = {
      userRole: 0
    }
    this.router.navigate(['/materials/', data._id], { queryParams: param })
    // this.router.navigate(['/materials/' + data._id])
    // }
  }

  // UTILITY

  updateData(courses) {
    console.log("UPDATING DATA = ", courses)
    this.dataSource = new MatTableDataSource(courses);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
  }

  goToSingleCourse(course) {
    // let navigationExtras: NavigationExtras = {
    //   state: {
    //     isCourse: true
    //   }
    // };
    // this.router.navigateByUrl('/materials/' + course._id, navigationExtras);
    let param = {
      userRole: 0
    }
    this.router.navigate(['/course/materials/', course._id], { queryParams: param })
  }

  // MODALS
  addCourseModal() {
    let addedCourse = this.openDialog(AddCourseModalComponent).subscribe((courses) => {
      if (courses == undefined) return;
      console.log("Course added in controller = ", courses);
      this.courses.push(courses);
      this.openSnackBar("Course added successfully!", "Ok");
      this.updateData(this.courses);
    }, err => {
      return this.openSnackBar("Course could not be added!", "Ok");
    });
  }


  editCourseModal(index, data) {
    this.openDialog(EditCourseModalComponent, data).subscribe((course) => {
      console.log("DIALOG CLOSED", course)

      // Handle Undefined
      if (!course) { return }
      // Handle Error
      if (course.result == "err") return this.openSnackBar("Course could not be edited!", "Ok");

      // EDIT HANDLE
      if (course.action == 'edit') {
        console.log("HANDLING EDIT SUCCESS", course.data);
        data = course.data;
        let Index = this.courses.findIndex(function (i) {
          return i._id === data._id;
        })
        this.courses[Index] = course.data;
        this.handleSnackBar({ msg: "Course edited successfully!", button: "Ok" });
      }
      // DELETE HANDLE
      else if (course.action == 'delete') {
        console.log("Deleted ", course);
        this.courses.splice(this.courses.findIndex(function (i) {
          return i._id === data._id;
        }), 1);
        this.handleSnackBar({ msg: "Course deleted successfully!", button: "Ok" });
        this.router.navigate(['/courses']);
      }
      this.updateData(this.courses);
    }, err => {
      console.log('Errro:', err);
    });
  }



  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  // API CALLS

  getCourses() {
    let that = this;
    this._courseService.getCourses().subscribe((courses) => {
      this.courses = courses;
      this.loading = false;
      this.updateData(courses)
    });
  }
}
